import * as icons from "src/components/icons";
import { IIconProps } from "src/components/icons";

export interface IFeedCardIconProps extends IIconProps {
    icon: keyof typeof icons;
}

export const FeedCardIcon = ({ icon, ...props }: IFeedCardIconProps) => {
    const IconComponent = icons[icon];
    return IconComponent ? <IconComponent {...props} /> : null;
};
